import ReactECharts from 'echarts-for-react';
import dayjs from 'dayjs';
import { chartColors, chartGrid, chartText } from '../../lib/chartColors';
import AnnotatedTimeChart from './AnnotatedTimeChart';

const order=['BENZINA-1','BENZINA-0','GASOLIO-1','GASOLIO-0','GPL-1','GPL-0','METANO-1','METANO-0'];
const names={BENZINA:'Benzina',GASOLIO:'Diesel',GPL:'GPL',METANO:'Metano'};

export default function AnnualFuelComparisonChart({items=[],height=440,metric='average_price',normalize=false}){
  const dates=[...new Set(items.map(x=>x.snapshot_date))].sort();
  const byKey={};
  items.forEach(x=>{const key=`${x.canonical_fuel_code}-${Number(x.is_self)}`;(byKey[key]??={})[x.snapshot_date]=Number(x[metric]);});
  const keys=order.filter(k=>byKey[k]);
  const series=keys.map((key,index)=>{
    const [fuel,self]=key.split('-');
    const raw=dates.map(d=>byKey[key][d]??null);
    const base=raw.find(v=>Number.isFinite(v)&&v>0);
    const values=normalize&&base?raw.map(v=>Number.isFinite(v)?Number((v/base*100).toFixed(3)):null):raw;
    return {name:`${names[fuel]||fuel} · ${self==='1'?'Self':'Servito'}`,type:'line',showSymbol:false,symbol:'none',connectNulls:false,data:values,lineStyle:{width:index<4?3:2,color:chartColors[index%chartColors.length],cap:'round'},itemStyle:{color:chartColors[index%chartColors.length]},emphasis:{focus:'series'}};
  });
  const option={
    animationDuration:420,
    grid:{left:54,right:14,top:82,bottom:42},
    legend:{top:4,type:'scroll',textStyle:{fontFamily:'Rubik',fontSize:11,color:chartText,fontWeight:500}},
    tooltip:{trigger:'axis',backgroundColor:'#fff8f9',borderWidth:0,padding:12,textStyle:{fontFamily:'Rubik',color:'#24191c'},extraCssText:'border-radius:18px;box-shadow:0 2px 8px rgba(35,25,27,.14);',formatter:(params)=>{const i=params?.[0]?.dataIndex??0;const date=dates[i]?dayjs(dates[i]).format('DD/MM/YYYY'):'';return `<b>${date}</b><br>${params.filter(p=>p.value!==null&&p.value!==undefined).map(p=>`${p.marker} ${p.seriesName}: <b>${normalize?`${Number(p.value).toFixed(1)} indice`:`${Number(p.value).toFixed(3)} €`}</b>`).join('<br>')}`;}},
    xAxis:{type:'category',data:dates,boundaryGap:false,axisLabel:{hideOverlap:true,color:chartText,fontFamily:'Rubik',fontSize:10,formatter:v=>dayjs(v).format('DD/MM')},axisLine:{lineStyle:{color:chartGrid}},axisTick:{show:false}},
    yAxis:{type:'value',scale:true,axisLabel:{formatter:v=>normalize?Number(v).toFixed(0):`${Number(v).toFixed(2)} €`,color:chartText,fontFamily:'Rubik',fontSize:10},splitLine:{lineStyle:{color:chartGrid}},axisLine:{show:false},axisTick:{show:false}},
    dataZoom:[{type:'inside',filterMode:'none'}],
    series
  };
  if(!dates.length) return <ReactECharts style={{height}} option={option}/>;
  return <AnnotatedTimeChart
    option={option}
    dates={dates}
    height={height}
    fuels={['BENZINA','GASOLIO']}
    analysisSeries={series.filter((_,index)=>keys[index]?.startsWith('BENZINA-')||keys[index]?.startsWith('GASOLIO-')).map(item=>({name:item.name,values:item.data}))}
    analysisUnit={normalize?'index':'price'}
  />;
}
